import getPcm from '../../_utils/get-pcm'

const adSspExposure = function(dom, data, spmCode) {
    let domWrap = document.createElement('div');    
    let codeWrap = document.createElement('a');
    codeWrap.setAttribute('href', 'javascript:void(0);');
    // PCM参数处理
    codeWrap.setAttribute('data-spm-content', getPcm(data));    
    codeWrap.appendChild(dom);
    if (spmCode) {
        domWrap.setAttribute('data-spm', spmCode);
        domWrap.appendChild(codeWrap);
    }
    return spmCode ? domWrap : codeWrap;
}

export default adSspExposure